import { render, staticRenderFns } from "./tophead.vue?vue&type=template&id=0665744e&scoped=true&"
import script from "./tophead.vue?vue&type=script&lang=js&"
export * from "./tophead.vue?vue&type=script&lang=js&"
import style0 from "./tophead.vue?vue&type=style&index=0&id=0665744e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0665744e",
  null
  
)

export default component.exports